var map = {
	"./cloud_load_balancing.svg": 9809,
	"./cloud_sql.svg": 4807,
	"./compute_engine.svg": 1339,
	"./error_reporting.svg": 8216,
	"./trace.svg": 3274,
	"./virtual_private_cloud.svg": 7778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4789;